import React from "react";
import _ from "i18n";

const Footer = () => (
  <footer id="footer">
    <div className="main-footer row align-center p-y-m">
      <div className="column small-2">
        <img alt="" src="/img/full-logo.svg" />
      </div>
      <div className="column small-3 footer__apps">
        <ul>
          <li>
            <span className="icon">
              <img src={"/img/icons/fb_icon.svg"} alt={""} />
            </span>
          </li>
          <li>
            <span className="icon">
              <img src={"/img/icons/linkedin_icon.svg"} alt={""} />
            </span>
          </li>
          <li>
            <span className="icon icon-social-instagram" />
          </li>
          <li>
            <span className="icon icon-social-google" />
          </li>
        </ul>
      </div>
      <div className="column small-6 footer__about">
        <p className="p-x-s">
          <b>Tamtam.pro </b>
          {_("about_us_content")}
        </p>
      </div>
    </div>
    <div className="copyright row">
      <p>
        © Copyright - {new Date().getFullYear()}{" "}
        <strong>Tamtam International</strong>
      </p>
    </div>
  </footer>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Layout/Footer.js